<ng-template #loadingOrError>
  <div *ngIf="error$ | async;else loading" class="error-container">
    <h3>Fehler beim Laden der Bilder</h3>
  </div>
  <ng-template #loading>
    <app-progress-indicator [progressText]="'Lade Bilder'" [inProgress]="true"></app-progress-indicator>
  </ng-template>
</ng-template>

<ng-container *ngIf="radarImages$ | async as images;else loadingOrError">

  <div class="wetter_content_container" style="text-align: center">

    <h3>Regenradar für Deutschland</h3>
    <button style="border-radius: 18px" mat-stroked-button (click)="reload()">
      <mat-icon color="primary">refresh</mat-icon>
      Erneut laden
    </button>


    <mat-horizontal-stepper labelPosition="bottom" [linear]="false" [@.disabled]="true">
      <ng-template matStepperIcon="edit">
        <mat-icon>map</mat-icon>
      </ng-template>
      <ng-template matStepperIcon="done">
        <mat-icon>map</mat-icon>
      </ng-template>

      <ng-container *ngFor="let image of images">
        <mat-step>
<!--          <div class="regenradar-bild-container">-->
            <ng-template class="mat-step-header" matTooltip="{{image.zeitstempel}} "
                         matStepLabel>{{image.zeitstempel | date: 'HH:mm'}}</ng-template>
            <div class="img-parent">
              <img class="img img-first-layer" src="./assets/regenradar/D_Radar_Hintergrund.png">
              <img class="img img-second-layer" src="./assets/regenradar/D_Radar_Grenzen.png">
              <img class="img img-third-layer" [src]="image.imageUrl" alt="{{image.imageUrl}}">
              <img class="img img-third-layer" src="./assets/regenradar/D_Radar_Staedte.png">
            </div>
<!--          </div>-->
          <button mat-button matStepperPrevious>
            <mat-icon>keyboard_arrow_left</mat-icon>
          </button>
          <button mat-button matStepperNext>
            <mat-icon>keyboard_arrow_right</mat-icon>
          </button>
        </mat-step>
        <!--  Hier Dateiname noch -->
      </ng-container>


    </mat-horizontal-stepper>
  </div>
</ng-container>
